// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"DeleteAppDetailsModal_deleteButton__18TeD"};